import { ValueOfKey } from '../../../../../../utils-types';

export const INGREDIENT_SEARCH_TAB = {
  CORE: 'CORE',
  SUPPLEMENT: 'SUPPLEMENT',
  VEGGIES: 'VEGGIES',
  NUTRITIONIX: 'NUTRITIONIX',
} as const;

export type IngredientSearchTab = ValueOfKey<typeof INGREDIENT_SEARCH_TAB>;
